(() => {
  const DIGITAL_PRODUCT_URL = '/products/get-nigelled-personalised-digital-reveal';
  const ORIGINAL_PAGE_URL = '/pages/commission-a-nigel';
  const COMMISSION_PRODUCT_URL = '/products/commission-an-original-nigel';
  const COMMISSION_VARIANTS = {
    standard: '59293669785925',
    framed: '59293669818693',
    bespoke: '59293669851461'
  };

  function polishUploadLinks(root = document) {
    root.querySelectorAll?.('.cart-items__properties a[href*="/uploads/"]').forEach((link) => {
      if (link.dataset.nigelUploadPolished === 'true') return;
      const originalFilename = link.textContent.trim();
      link.dataset.nigelUploadPolished = 'true';
      link.setAttribute('aria-label', originalFilename ? `View uploaded reference photo: ${originalFilename}` : 'View uploaded reference photo');
      link.textContent = 'Uploaded ✓';
    });
  }

  // The homepage hero is rendered by sections/nigel-gallery-home.liquid.
  // Do not inject a second hero from JavaScript.
  function addHomepageHero() {
    return;
  }

  function getCommissionVariant(text) {
    const value = (text || '').toLowerCase();
    if (value.includes('395') || value.includes('bespoke')) return COMMISSION_VARIANTS.bespoke;
    if (value.includes('175') || value.includes('framed')) return COMMISSION_VARIANTS.framed;
    if (value.includes('95') || value.includes('standard')) return COMMISSION_VARIANTS.standard;
    return null;
  }

  function addCommissionPagePayments() {
    if (!window.location.pathname.includes('/pages/commission-a-nigel')) return;
    const page = document.querySelector('.nigel-commission-page');
    if (!page) return;

    if (!document.getElementById('commission-offer-split')) {
      const split = document.createElement('div');
      split.id = 'commission-offer-split';
      split.className = 'nc-offer-split';
      split.innerHTML = `
        <div class="nc-offer-split__item">
          <span class="nc-offer-split__eyebrow">THE REVEAL</span>
          <strong>Get someone Nigelled — £49</strong>
          <p>Digital artwork plus a personalised reveal video. No physical artwork is posted.</p>
          <a href="${DIGITAL_PRODUCT_URL}">Choose the digital reveal ↗</a>
        </div>
        <div class="nc-offer-split__item">
          <span class="nc-offer-split__eyebrow">THE ORIGINAL</span>
          <strong>Commission a physical original — from £95</strong>
          <p>A hand-drawn, signed and dated original. Choose Standard, Framed or Bespoke below.</p>
          <span class="nc-secure-note">You’re in the right place ↓</span>
        </div>`;
      const intro = page.querySelector('.nc-intro');
      if (intro) intro.insertAdjacentElement('afterend', split);
      else page.prepend(split);
    }

    const mailLinks = [...page.querySelectorAll('a[href^="mailto:"]')];
    mailLinks.forEach((link, index) => {
      const container = link.closest('.nc-tier, article, section, div');
      let variant = getCommissionVariant(container?.textContent || link.parentElement?.textContent || '');
      if (!variant && index < 3) variant = [COMMISSION_VARIANTS.standard, COMMISSION_VARIANTS.framed, COMMISSION_VARIANTS.bespoke][index];
      if (!variant) return;
      link.href = `${COMMISSION_PRODUCT_URL}?variant=${variant}`;
      link.removeAttribute('target');
      link.dataset.commissionPayLink = 'true';
      link.textContent = 'Choose & pay securely ↗';
      const parent = link.parentElement;
      if (parent && !parent.querySelector('.nc-secure-note')) {
        const note = document.createElement('p');
        note.className = 'nc-secure-note';
        note.textContent = 'Secure Shopify checkout · available payment methods are shown at checkout.';
        parent.appendChild(note);
      }
    });

    [...page.querySelectorAll('p')].forEach((paragraph) => {
      if (paragraph.textContent.toLowerCase().includes('payment link')) {
        paragraph.textContent = 'Choose your commission above, complete the brief and pay securely through Shopify. I’ll confirm the details and delivery timing by email before I begin.';
      }
    });
  }

  function addCommissionProductBrief() {
    if (!window.location.pathname.includes('/products/commission-an-original-nigel')) return;
    const main = document.querySelector('main');
    if (main) main.classList.add('gn-commission-product');

    document.querySelectorAll('product-form-component form[data-type="add-to-cart-form"]').forEach((form) => {
      if (form.querySelector('.gn-commission-brief')) return;
      form.enctype = 'multipart/form-data';
      const buttons = form.querySelector('.product-form-buttons');
      if (!buttons) return;

      const brief = document.createElement('div');
      brief.className = 'gn-commission-brief';
      brief.innerHTML = `
        <h3>Tell me who I’m drawing.</h3>
        <p class="gn-commission-brief__intro">Complete the brief below, then add the commission to your cart or use the express payment option shown underneath.</p>
        <label class="gn-commission-field">
          <span>Recipient’s name *</span>
          <input type="text" name="properties[Recipient name]" maxlength="80" required autocomplete="off">
        </label>
        <label class="gn-commission-field">
          <span>Occasion</span>
          <input type="text" name="properties[Occasion]" maxlength="120" placeholder="Birthday, wedding, retirement…" autocomplete="off">
        </label>
        <label class="gn-commission-field">
          <span>Tell me about them / what should be in the drawing *</span>
          <textarea name="properties[Commission brief]" maxlength="600" required placeholder="A few personal details, an inside joke, hobbies, pets or anything else I should know."></textarea>
        </label>
        <label class="gn-commission-field">
          <span>Needed by</span>
          <input type="date" name="properties[Needed by]">
          <small>I’ll confirm that the date is achievable before I begin.</small>
        </label>
        <label class="gn-commission-field">
          <span>Reference photo</span>
          <input type="file" name="properties[Reference photo]" accept="image/*">
          <small>Optional, but useful if the drawing is based on a particular person, pet or scene.</small>
        </label>
        <p class="gn-commission-brief__footer">This is for a physical, hand-drawn original. A personalised reveal video is not included. <a class="gn-commission-brief__digital" href="${DIGITAL_PRODUCT_URL}">Just want the digital reveal? Get someone Nigelled for £49 ↗</a></p>`;
      buttons.insertAdjacentElement('beforebegin', brief);
    });
  }

  function run() {
    polishUploadLinks();
    addHomepageHero();
    addCommissionPagePayments();
    addCommissionProductBrief();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;
        polishUploadLinks(node);
      }
    }
    addHomepageHero();
    addCommissionPagePayments();
    addCommissionProductBrief();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();